export const CLOSE_SUB_HEADER = 'CLOSE_SUB_HEADER'
export const closeSubHeaderAction = () => {
  return {
    type: 'CLOSE_SUB_HEADER',
    payload: false,
  }
}

export const TOGGLE_SUB_HEADER = 'TOGGLE_SUB_HEADER'
export const toggleSubHeaderAction = (nextState: boolean) => {
  return {
    type: 'TOGGLE_SUB_HEADER',
    payload: nextState,
  }
}
